"use client";
import { cn } from "@/lib/utils";
import { useScopedI18n } from "@/messages/client";
import { useEffect, useRef, useState } from "react";

interface Props {
  children?: React.ReactNode;
  loading?: boolean;
  width?: string;
  height?: string;
  className?: string;
  hideText?: boolean;
}

function Loading({
  children,
  loading = true,
  width = "2em",
  height = "2em",
  className,
  hideText = false,
}: Props) {
  const t = useScopedI18n("通用");

  const timer = useRef<NodeJS.Timeout>();

  const [isLoading, set] = useState(false);

  useEffect(() => {
    if (loading) {
      set(true);
    } else {
      timer.current = setTimeout(() => {
        set(false);
      }, 200);
    }

    return () => {
      if (timer.current) {
        clearTimeout(timer.current);
      }
    };
  }, [loading]);

  return (
    <div className={cn("relative", className)}>
      {isLoading && (
        <div>
          <div className="absolute top-0 block h-full w-full">
            <div className="absolute left-1/2 top-1/2 flex -translate-x-1/2 -translate-y-1/2 flex-col items-center text-primary">
              <svg
                fill="none"
                stroke="currentColor"
                strokeWidth="4"
                width={width}
                height={height}
                viewBox="0 0 48 48"
                aria-hidden="true"
                focusable="false"
                className="animate-spin">
                <path d="M42 24c0 9.941-8.059 18-18 18S6 33.941 6 24 14.059 6 24 6"></path>
              </svg>

              {!hideText && <span className="mt-3">{t("加载中")}</span>}
            </div>
          </div>
        </div>
      )}

      <div
        className={cn("relative transition-opacity duration-300", {
          "pointer-events-none clear-both select-none opacity-50": isLoading,
        })}>
        {children}
      </div>
    </div>
  );
}

export default Loading;
